import React from "react"
import { FlyOutPanel } from "@4cplatform/elements/Molecules"

// Components
import QuoteView from "./quotes.panel.view"

const QuotesPanel = () => <FlyOutPanel body={() => <QuoteView />} name="quotes_panel" />

export default QuotesPanel
